import React from 'react'
import { makeStyles } from '@paintscout/ui'
import type { AlbumPhoto } from '@paintscout/util/pexels'
import { distributeToColumns } from '@paintscout/util/pexels'
import PhotoOption from './PhotoOption'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-start'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0
  }
})

export interface PhotoMasonryProps {
  photos: AlbumPhoto[]
  columns: number
  spacing?: number
}

/**
 * Lightweight, dependency-free masonry grid. Distributes photos into balanced columns by
 * aspect ratio ({@link distributeToColumns}) and lays them out with flexbox — no external
 * masonry library needed.
 */
function PhotoMasonry({ photos, columns, spacing = 8 }: PhotoMasonryProps) {
  const classes = useStyles()
  const cols = distributeToColumns(photos, columns)

  return (
    <div className={classes.root} style={{ gap: spacing }}>
      {cols.map((col, index) => (
        <div key={index} className={classes.column} style={{ gap: spacing }}>
          {col.map((photo) => (
            <PhotoOption key={photo.key} photo={photo} />
          ))}
        </div>
      ))}
    </div>
  )
}

export default PhotoMasonry
